/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_SentInputs */

const en_invoice_request_sent = /** @type {(inputs: Invoice_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request sent to your trainer`)
};

const pl_invoice_request_sent = /** @type {(inputs: Invoice_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prośba wysłana do trenera`)
};

/**
* | output |
* | --- |
* | "Request sent to your trainer" |
*
* @param {Invoice_Request_SentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_sent = /** @type {((inputs?: Invoice_Request_SentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_SentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_sent(inputs)
	return en_invoice_request_sent(inputs)
});